import React from 'react';
import {Card, CardBody} from 'reactstrap';
import styles from '@/views/Layout/b2b/index.module.css';
import {avenueB2bLink} from '@/config';
import usePermission from '@/hooks/usePermission';

const AvenueLink = () => {
  const permission = usePermission();

  if (permission.canAccessAvenueB2b()) {
    return (
      <Card className='mb-4'>
        <CardBody className={styles.sortable_list_box_body}>
          <a
            href={`${avenueB2bLink}`}
            target='_blank'
            rel='noopener noreferrer'
          >
            Avenue B2B
          </a>
        </CardBody>
      </Card>
    );
  }

  return null;
};

export default AvenueLink;
